import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { useEffect } from 'react';
import { useState } from 'react';

//https://stripe.com/docs/stripe-js/react
export function PaymentForm({ stripe_client_secret }) {
  const stripe = useStripe();
  const elements = useElements();

  const [options, setOptions] = useState({
    clientSecret: stripe_client_secret
  })

  useEffect(() => {
    setOptions({
      ...options,
      clientSecret: stripe_client_secret
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stripe_client_secret])

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const result = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: "https://example.com/order/123/complete",
      },
    });

    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
      console.log(result.error.message);
    } else {
      console.log(result);
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  };

  return (
    <form onSubmit={handleSubmit} >
      <PaymentElement />
      <button disabled={!stripe} type='submit'>Submit</button>
    </form >
  )
}